import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { AuthState } from "context/AuthContext";
import { getApprovalStatus } from "utils/supplierApprovalHelpers";
import { SupplierStatusChip } from "../shared/supplierUi";

const softBtn = {
	textTransform: "none",
	fontWeight: 600,
	fontSize: 14,
	borderRadius: 1.5,
	px: 1.5,
	py: 0.5,
	minHeight: 32,
	boxShadow: "none",
	"&:hover": { boxShadow: "none" },
};

const StatusButtons = ({
	handleReject,
	disableEdit,
	handleEdit,
	approved,
	handleApproval,
	handleUnapprove,
	editButton,
	buttonName,
	remark,
	action,
	otherAccess,
}) => {
	const { user } = AuthState();
	const disableEditAndApproval = user.role?.SUPPLIER_VIEWER ? true : false;
	const status = getApprovalStatus({ approved, remark, action });
	const isApproved = status === "Approved";
	const isRejected = status === "Rejected";
	const isPending = status === "Pending";
	const canAct = disableEdit && isPending && !disableEditAndApproval && otherAccess;

	return (
		<Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap" useFlexGap>
			{canAct ? (
				<>
					<Button
						variant="contained"
						onClick={handleApproval}
						sx={{
							...softBtn,
							bgcolor: "#027A48",
							color: "#fff",
							"&:hover": { bgcolor: "#02603a", boxShadow: "none" },
						}}>
						Approve
					</Button>
					<Button
						variant="outlined"
						onClick={handleReject}
						sx={{
							...softBtn,
							borderColor: "#FDA29B",
							color: "#B42318",
							bgcolor: "#FEF3F2",
							"&:hover": { borderColor: "#F97066", bgcolor: "#FEE4E2" },
						}}>
						Reject
					</Button>
				</>
			) : null}

			{isApproved ? (
				<>
					<SupplierStatusChip label="Approved" />
					{disableEdit && !disableEditAndApproval && otherAccess && typeof handleUnapprove === "function" ? (
						<Button
							variant="outlined"
							onClick={handleUnapprove}
							sx={{
								...softBtn,
								borderColor: "#FEC84B",
								color: "#B54708",
								bgcolor: "#FFFAEB",
								"&:hover": { borderColor: "#FDB022", bgcolor: "#FEF0C7" },
							}}>
							Unapprove
						</Button>
					) : null}
				</>
			) : isRejected ? (
				<SupplierStatusChip label="Rejected" />
			) : disableEdit ? (
				disableEditAndApproval ? <SupplierStatusChip label="Pending" /> : null
			) : (
				<SupplierStatusChip label="Pending" />
			)}

			{!disableEdit && editButton && !isApproved ? (
				<Button
					variant="contained"
					onClick={handleEdit}
					sx={{
						...softBtn,
						bgcolor: "#212121",
						color: "#fff",
						"&:hover": { bgcolor: "#000", boxShadow: "none" },
					}}>
					{buttonName}
				</Button>
			) : null}
		</Stack>
	);
};

export default StatusButtons;
